

  import { Component, Vue } from 'vue-property-decorator'
  import axios from 'axios';
  import { GF } from '../helpers/gf';
  import { FILTERS } from "../helpers/filters";
  import "../helpers/helpers";

  import WrsLabel from './wrsControls/WrsLabel.vue';
  import WrsAlert from './wrsControls/WrsAlert.vue';
  import WrsSecurityDialog from './wrsControls/WrsSecurityDialog.vue';
  import WrsWizardStepHeader from './wrsControls/WrsWizardStepHeader.vue';
  import WrsWizardStepButtons from './wrsControls/WrsWizardStepButtons.vue';
  import WrsSearchButtons from './wrsControls/WrsSearchButtons.vue';

  import WrsViLabel from './wrsControls/viControls/WrsViLabel.vue';
  import WrsViSelect from './wrsControls/viControls/WrsViSelect.vue';
  import WrsViText from './wrsControls/viControls/WrsViText.vue';
  import WrsViTextArea from './wrsControls/viControls/WrsViTextArea.vue';
  import WrsViDate from './wrsControls/viControls/WrsViDate.vue';
  import WrsViWeekDate from './wrsControls/viControls/WrsViWeekDate.vue';
  import WrsViNumeric from './wrsControls/viControls/WrsViNumeric.vue';
  import WrsViCheckbox from './wrsControls/viControls/WrsViCheckbox.vue';

  //import WrsFee from './wrsControls/WrsFee.vue';

  import { IS_PRODUCTION_ENVIRONMENT, IS_VUEJS_ENVIRONMENT } from '../../olsStateManagement/helpers/constants';
  import { userService } from '../../olsStateManagement/services/devAuth.service';
  import AuthService from '../../olsStateManagement/services/auth.service';
  import {DEFAULT_ROOT_URL} from '../../olsStateManagement/helpers/constants'

  const authService = new AuthService();

  @Component({
    components: {
      'wrs-alert': WrsAlert,
      'wrs-security-dialog': WrsSecurityDialog,
      'wrs-wizard-step-header': WrsWizardStepHeader,
      'wrs-wizard-step-buttons': WrsWizardStepButtons,
      'wrs-search-buttons': WrsSearchButtons,

      'wrs-vi-select': WrsViSelect,
      'wrs-vi-text': WrsViText,
      'wrs-vi-textarea': WrsViTextArea,
      'wrs-vi-numeric': WrsViNumeric,
      'wrs-vi-checkbox': WrsViCheckbox,
      'wrs-label': WrsLabel,
      'wrs-vi-label': WrsViLabel,
      'wrs-vi-date': WrsViDate,
      'wrs-vi-week-date': WrsViWeekDate,

      //'wrs-fee': WrsFee,
    },
  })

  export default class App extends Vue {
    public VM: any = {};

    public INITTYPE: any = {
      INIT: 0,
      BOOKEXAM: 1,
      REBOOKEXAM: 2
    };

    public STEPIDS: any = {
      stepSelectExam: 1,
      stepFinish: 2,
      //stepAddToCart: 3,
      stepValidation: 3
    };

    public EXAMTYPE: any = {
      WRITTEN: 1,
      PRACTICAL: 2
    };

    public WEEKDAYS: any = [
        { id: 1, name: "Sunday" },
        { id: 2, name: "Monday" },
        { id: 3, name: "Tuesday" },
        { id: 4, name: "Wednesday" },
        { id: 5, name: "Thursday" },
        { id: 6, name: "Friday" },
        { id: 7, name: "Saturday" }
    ]

    public currentOlsUser: any = {};
    public clientData: any = {};

    public isAuthorized: boolean = false;
    public emailVerified: boolean = false;
    public userName: string = ""

    public loader: any = {
      loaded: false,
      loadedNoError: false,
      loading: false
    };

    public schedulerDialogLoading: boolean = false;

    // EXAM BOOKING
    public selectedExamBooking: any = {};
    // EXAM
    public selectedExam: any = {};
    public selectedExamOrderId: number = 0;
    public examList: any = [];

    //Exam Slot
    public selectedExamTimeSlotId: number = 0;
    public selectedExamTimeSlot: any = {};

    public scheduleDialog: any = {
      isOpen: false,
      title: "",
      confirmText: "",
      denyText: "",
      wizardInitType: ""
    }

    public cancelExamBookingDialog: any = {
      isOpen: false,
      title: "",
      confirmText: "",
      denyText: "",
    }

    // Mobile funcions
    public isMobile: boolean = false;
    onResize() {
      //window.innerWidth < 769
      if (window.innerWidth < 821)
        this.isMobile = true;
      else
        this.isMobile = false;
    }

    public expandedRows: any = [];
    public mobileRowExpanded: boolean = false;
    expandRow(index: any){ 
      const indexOfRow = this.expandedRows.indexOf(index)
      if(indexOfRow > -1){
        this.mobileRowExpanded = false;
        this.expandedRows.splice(indexOfRow,1);
        return;
      }
      this.mobileRowExpanded = true;
      this.expandedRows.push(index);
    }
    // Mobile funcions end

    // created() {
    //  if (!IS_PRODUCTION_ENVIRONMENT && IS_VUEJS_ENVIRONMENT) {
    //    import('../../olsStateManagement/css/olsOverrideDev.scss')
    //    .catch(error => {
    //     console.error('Error importing SCSS file:', error);
    //   });
    //  }
    // }

    mounted() {
      this.startWizard();
      this.onResize();
    }

    cancelWizard() {
      //if wizard is canceled, clear all the time slots currently reserved but not in cart
      this.acceptOrClearSchedule(true, false);
      this.startWizard();
    }

    startWizard() {
      //this.VM.currentStepId = this.STEPIDS.stepVehicle;
      this.loader.loaded = false;
      this.loader.loadedNoError = false;
      this.loader.loading = false;

      this.selectedExam = {};
      this.selectedExamOrderId = 0;

      // this.spacingIsRecalculated = false;
      // this.weightIsRecalculated = false;

      if (!IS_PRODUCTION_ENVIRONMENT && IS_VUEJS_ENVIRONMENT) {
        let userData = userService.getUser();
        userData
          .then((result) => {
            this.clientData = JSON.parse(JSON.stringify(result));
            this.loadData();
            this.isAuthorized = this.clientData.isLoggedIn;
          });
      } else {

        authService.getUser()
          .then((user:any) => {
            if(user) {
              this.emailVerified = authService.emailVerified();

              if(user.profile.email_verified) {
                this.isAuthorized = authService.isAuthorized();

                if(this.isAuthorized) {

                  this.userName = user.profile.name != null ? user.profile.name : user.profile.email;

                  let pOlsUser = sessionStorage.getItem('olsUser')
                  if(pOlsUser){
                    let olsUser = JSON.parse(pOlsUser);

                    axios
                      .get("olsUserProfile/getUserDefaultClient/" + olsUser.olsUserId + '/0/true',)
                        .then(response => {
                          this.clientData = response.data;
                          this.loadData()
                      })
                      .catch(error => console.log(error))

                  }

                }
                else {
                  authService.logout();
                }
              }
              // else in store.js user is redirected to email-not-verified page!
            }
          })
          .catch(error => console.log(error))
          .finally(() => {
            this.loader.loading = false;
            this.loader.loaded = true;
          })

      }
    }

    public async loadData() {
     
      this.loader.loading = true;

      axios
        .get('exams/initExamViewModel/' + this.clientData.olsUserId + '/' + this.clientData.clientId)
        .then(response => { this.VM = response.data; })
        .catch(error => console.log(error))
        .finally(() => {
          this.loader.loading = false;
          this.loader.loaded = true;
          this.loader.loadedNoError = !this.VM.securityError.hasError;

          this.scrollToTop();

        });
    }

    public cannotBeBooked: boolean = false;
    selectExam(id: number) {

      this.selectedExam = {};
      this.examGroupAvailableExamsList = this.VM.wizardInitType == this.INITTYPE.BOOKEXAM ? this.examGroupAvailableExams : this.examReBookExamList;

      let selectedExam = this.examGroupAvailableExamsList.filter((x: any) => x.id == id);
      if(selectedExam) {
        this.selectedExam = selectedExam[0];
        this.selectedExamOrderId = id;
      }

      this.clearExamSlot();

      if(this.VM.wizardInitType == this.INITTYPE.BOOKEXAM) {
        let postData = {
          clientId: this.clientData.clientId,
          examId: this.selectedExam.examId,
          isForRebook: false,
          isForCancel: false,
          languageId: this.VM.languageId
        }
  
        axios
          .post('exams/checkIfExamCanBeBooked', postData)
          .then(
              response => { 
                  if(response.data.hasError) {
                    // Show cannotBeBooked message, 
                    this.VM.examAlert = response.data;
                    this.cannotBeBooked = true;
                  } else {
                    this.cannotBeBooked = false;
                    this.VM.examAlert.hasError = false;
                    this.VM.examAlert.message = "";
                  }
                })
          .catch(error => console.log(error))
          .finally(() => {
            this.loader.loading = false;
            this.loader.loaded = true;
            this.loader.loadedNoError = !this.VM.securityError.hasError;
          });
      }

    }

    public getExamTypeByExamTypeId(examTypeId: number) {
      if (examTypeId === 1) {
        return 'WRITTEN'
      } else if (examTypeId === 2) {
        return 'PRACTICAL'
      }
    }

    public clearExamSlot(){
      // Clears exam slots selected when chossing between different exams from list
      this.selectedExamTimeSlot = {};
      this.selectedExamTimeSlotId = 0;
    }

    public getAvailableExamByExamGroupId() {

      // clear exam slots
      this.clearExamSlot();
      this.resetErrorAlert();

      let request = {
        clientId: this.clientData.clientId,
        examGroupId: this.VM.selectExamStep.examGroup.value,
        includeCombination: false,
        languageId: this.VM.languageId
      }

      axios
        .post('exams/getAvailableExamByExamGroupId', request)
        .then(
            response => { 
              let examsCanBeBooked = [];

              // FILTER TO ONLY EXAMS THAT CAN BE BOOKED
              if(response.data != null && response.data.length > 0) {
                examsCanBeBooked = response.data.filter((exam: any) => exam.cannotBook == false);
              }

              this.VM.selectExamStep.examGroupAvailableExams = examsCanBeBooked;

            })
        .catch(error => console.log(error))
        .finally(() => {
          this.loader.loading = false;
          this.loader.loaded = true;
          this.loader.loadedNoError = !this.VM.securityError.hasError;
          this.selectedExamOrderId = 0;                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                              
        });
    }

    public examGroupAvailableExamsList: any = [];
    get examGroupAvailableExams () {
      return this.VM.selectExamStep?.examGroupAvailableExams;
    }

    // public examReBookExamList: any = [];
    get examReBookExamList () {
      return this.VM.reBookExamStep?.examGroupAvailableExams;
    }

    public availableExamSlotItemsList: any = [];
    public availableExamSlots (wizardInitType: number) {
      if (wizardInitType === 1) {
        return this.VM.selectExamStep?.availableSlotItems;
      } else {
        return this.VM.reBookExamStep?.availableSlotItems;
      }
    }

    get examBookingsList () {
      return this.VM.examBookings;
    }
    

    public bookExam() {
      let postData = {
        initType: this.INITTYPE.BOOKEXAM,
        examStep: this.STEPIDS.stepSelectExam,
        olsId: this.clientData.olsId,
        clientId: this.clientData.clientId
      }

      axios
        .post('exams/getExamStepData', postData)
        .then(response => { this.VM = response.data; })
        .catch(error => console.log(error))
    }


    public getExamSchedulerData(isForReBook: boolean, examLocationChanged: boolean) {
      
      this.clearExamSlot();

      let postData = {
        clientId: this.clientData.clientId,
        examTypeId: this.selectedExam.examTypeId,
        examId: this.selectedExam.examId,
        cityId: this.clientData.cityId,
        // officeId: isForReBook ? this.VM.reBookExamStep.office.value : this.VM.selectExamStep.office.value,
        examLocationId: isForReBook ? this.VM.reBookExamStep.examLocation.value : this.VM.selectExamStep.examLocation.value,
        languageId: this.VM.languageId,
        examScheduleDate: isForReBook ? this.VM.reBookExamStep.examScheduleDate?.value : this.VM.selectExamStep.examScheduleDate?.value
      }
      
      // Initiate loader only when date picker value is actually changed or examLocation selection changed.
      // This is the only way date picker is not sending @input event twice causing wierd behavior with loader.
      // Please do not change, it will brake.
      // Goran U.
      
      if(postData.examScheduleDate != null){
        if(!postData.examScheduleDate.includes("T") || examLocationChanged) {
          this.schedulerDialogLoading = true;
        }
      }

      axios
        .post("exams/getExamSchedulerData", postData)
        .then(
            response => {
                if (isForReBook){
                  this.VM.reBookExamStep.availableSlotItems = response.data.availableSlotItems;
                  this.VM.reBookExamStep.availableSlots = response.data.availableSlots;
                  this.VM.reBookExamStep.examLocation = response.data.examLocations;
                  this.VM.reBookExamStep.examScheduleDate = response.data.examScheduleDate;
                } else {
                  this.VM.selectExamStep.availableSlotItems = response.data.availableSlotItems;
                  this.VM.selectExamStep.availableSlots = response.data.availableSlots;
                  this.VM.selectExamStep.examLocation = response.data.examLocations;
                  this.VM.selectExamStep.examScheduleDate = response.data.examScheduleDate;
                }
              })
        .catch(error => console.log(error))
        .finally(() => {
          this.loader.loading = false;
          this.loader.loaded = true;
          this.loader.loadedNoError = !this.VM.securityError.hasError;
          this.schedulerDialogLoading = false;
        });
    }

    // public filteredSlots(dayId: number, wizardInitType: number) {
    //   if (wizardInitType === 1) {
    //     return this.VM.selectExamStep?.availableSlotItems?.filter((item:any) => item.dayId === dayId);
    //   } else {
    //     return this.VM.reBookExamStep?.availableSlotItems?.filter((item:any) => item.dayId === dayId);
    //   }
    // }

    // public getFilteredSlotDate(dayId: number, wizardInitType: number): string {
    //   let slot;
      
    //   if (wizardInitType === 1) {
    //     slot = this.VM.selectExamStep?.availableSlotItems?.find((item: any) => item.dayId === dayId);
    //   } else{
    //     slot = this.VM.reBookExamStep?.availableSlotItems?.find((item: any) => item.dayId === dayId);
    //   }

    //   if (slot) {
    //       return FILTERS.dateToStringYMD(slot.availabilityDate);
    //     }
    //     return "";
    // }

    public fisnishStepExamDateFormatted(date: string) {
      return FILTERS.dateToStringDateWithWeekDay(date);
    }

    // filteredDaysWithSlots(wizardInitType: number) {
    //   // Filter days that have slot items available
    //   return this.WEEKDAYS.filter((day:any) => this.filteredSlots(day.id, wizardInitType)?.length > 0);
    // }


    // FILTERING SLOTS PER DAY (REQUESTED BY DOUG, CASE:17083)
    public timeSlotsByExamScheduleDate(wizardInitType: number) {
      if (wizardInitType === 1) {
        return this.VM.selectExamStep?.availableSlotItems?.filter((item: any) => FILTERS.dateToStringYMD(item.availabilityDate) == FILTERS.dateToStringYMD(this.VM.selectExamStep?.examScheduleDate.value));
      } else {
        return this.VM.reBookExamStep?.availableSlotItems?.filter((item: any) => FILTERS.dateToStringYMD(item.availabilityDate) == FILTERS.dateToStringYMD(this.VM.reBookExamStep?.examScheduleDate.value));
      }
    }


    selectExamTimeSlot(id: number, wizardInitType: number) {
      
      this.availableExamSlotItemsList = this.availableExamSlots(wizardInitType);

      var selectedSlot = this.availableExamSlotItemsList.filter((x: any) => x.id == id);
      
      if(selectedSlot) {
        this.selectedExamTimeSlot = selectedSlot[0];
        this.selectedExamTimeSlotId = id;
      }
    }

    public scheduleExam() {

      if(this.selectedExam != null){
        this.getExamSchedulerData(false, false);
      }

      this.scheduleDialog.wizardInitType = 1; // new exam
      this.scheduleDialog.isOpen = true;

      this.schedulerDialogLoading = true;
    }

    public scheduleReBookExam() {

      if(this.selectedExam != null){
        this.getExamSchedulerData(true, false);
      }
            
      this.scheduleDialog.wizardInitType = 2; // rebook
      this.scheduleDialog.isOpen = true;

      this.schedulerDialogLoading = true;
    }

    // #region REBOOK

    public rebookExam(examBookingId: number) {
      
      this.clearExamSlot();
      var selectedExamBooking = this.VM.examBookings.filter((x: any) => x.examBookingId == examBookingId);
      
      let postData = {
        clientId: this.clientData.clientId,
        examId: selectedExamBooking[0]?.examId,
        isForRebook: true,
        isForCancel: false,
        languageId: this.VM.languageId
      }

      axios
        .post('exams/checkIfExamCanBeBooked', postData)
        .then(
            response => { 
                if(response.data.hasError) {
                  // Show cannotBeBooked message, 
                  this.VM.examAlert = response.data;
                  this.cannotBeBooked = true;
                } else {
                  this.cannotBeBooked = false;
                  this.VM.examAlert.hasError = false;
                  this.VM.examAlert.message = "";

                  let postData = {
                    initType: this.INITTYPE.REBOOKEXAM,
                    examStep: this.STEPIDS.stepSelectExam,
                    olsId: this.clientData.olsId,
                    clientId: this.clientData.clientId,
                    examBookingId: examBookingId
                  }

                  axios
                    .post('exams/getExamStepData', postData)
                    .then(response => { 
                      this.VM = response.data; 
                      this.selectedExamOrderId = 1;
                      this.selectedExam = response.data.reBookExamStep?.examGroupAvailableExams[0];
                    })
                    .catch(error => console.log(error))

                }
              })
        .catch(error => console.log(error))
        .finally(() => {
          this.loader.loading = false;
          this.loader.loaded = true;
          this.loader.loadedNoError = !this.VM.securityError.hasError;
        });
    }
    // #endregion

    public openCancelExamBookingDialog(examBookingId: number) {
      this.selectedExamBooking = this.VM.examBookings.filter((x: any) => x.examBookingId == examBookingId);
      this.cancelExamBookingDialog.isOpen = true;
    }
    
    public cancelExamBooking() {
      if(this.selectedExamBooking != null) {
        
        let postData = {
          examBookingId: this.selectedExamBooking[0]?.examBookingId,
          isOnlyDelete: false,
          modifiedBy: 0,
        }

        axios
        .post('exams/deleteExamBooking', postData)
        .then(response => { 
          if(response.data.hasSuccess){
            this.cancelExamBookingDialog.isOpen = false;
            this.startWizard();
          }else{
            //slot is not saved/updated
            this.examScheduleAccepted = false;
          }
         })
        .catch(error => console.log(error))
      }
    }

    public examScheduleAccepted: boolean | null = null;
    public acceptOrClearSchedule(forClear: boolean, isRebook: boolean) {
    
      // list of exam slots that occupied one time slot, example: 9:00-10:00 have 4 time slots of 15min. We need to send id's of those 4 time slots as a list.
      let examSlotList = [];
      if(isRebook) {
        examSlotList = this.VM.reBookExamStep?.availableSlots?.filter((x:any) => x.eaD_ID == this.selectedExamTimeSlotId).map(((y:any) => y.slotId));
      }else{
        examSlotList = this.VM.selectExamStep?.availableSlots?.filter((x:any) => x.eaD_ID == this.selectedExamTimeSlotId).map(((y:any) => y.slotId));
      }

      let postData = {
        isSlotAccepted: true,
        examId: forClear ? 0 : this.selectedExam.examId,
        isVerbal: false,
        clientId: this.clientData.clientId,
        examWizardId: isRebook ? this.VM.reBookExamStep?.examWizardId : this.VM.selectExamStep?.examWizardId,
        examSlotIds: examSlotList != null ? examSlotList : []
      }

      axios
        .post('exams/updateExamSlotTaken', postData)
        .then(response => { 
          if(response.data.hasSuccess){
            this.examScheduleAccepted = true;
            this.scheduleDialog.isOpen = false;
          }else{
            //slot is not saved/updated
            this.examScheduleAccepted = false;
          }
         })
        .catch(error => console.log(error))
    }

    public cancelSchedule() {
      this.scheduleDialog.isOpen = false;
      this.selectedExamTimeSlotId = 0;
      this.examScheduleAccepted = null;
    }

    //All Steps Related
    
    get isScheduled() {
      return this.selectedExam.examTypeId == this.EXAMTYPE.PRACTICAL && this.selectedExamTimeSlotId != null && this.selectedExamTimeSlotId > 0;
    }
    
    canGoToNextStep(currentStepId: number) {
      
      if(currentStepId == this.STEPIDS.stepSelectExam) {
        if(this.selectedExamOrderId > 0 && !this.cannotBeBooked && this.selectedExam.examTypeId == this.EXAMTYPE.WRITTEN && this.VM.disclamer.value == true) {
          return true;
        }else if(this.selectedExamOrderId > 0 && this.isScheduled && !this.cannotBeBooked && this.VM.disclamer.value == true) {
          return true;
        }else{
          return false;
        }
      }

      return false;
    }

    loadNextStep(stepId: number) {
      if (!this.canGoToNextStep(stepId)) return;

      if (stepId == this.STEPIDS.stepSelectExam) {
        this.VM.currentStepId = this.STEPIDS.stepFinish;

        let postData = {
          initType: this.INITTYPE.BOOKEXAM,
          examStep: this.STEPIDS.stepFinish,
          olsUserId: this.clientData.olsUserId,
          clientId: this.clientData.clientId
        }

        axios
          .post('exams/getExamStepData', postData)
          .then(response => { 
            this.VM.finishStep = response.data; })
          .catch(error => console.log(error))
          .finally( () => {
            this.scrollToTop();
          })
      }
    }

    canAddToCart() {
      if (this.VM.runtimeError.hasError) return false;

      var count = 1; //this.VM.selectExamStep.;
      var isReachedMax = false;
      if (count > this.VM.countOfCartItemsCanBeAdded) {
        isReachedMax = true;
        GF.setAlertWarning(this.VM.runtimeError, this.VM.maximumOfCartItemsReachedError);
      }
      else {
        GF.clearAlert(this.VM.runtimeError);
      }

      var anySelected = count > 0;

      return !this.VM.disclamer.error && !this.VM.examAlert.hasError && anySelected && !isReachedMax;
    }

    addToCart() {
      if (this.canAddToCart()) {

        let examLocationId = 0
        let examBookedOn = null
        let examWizardId = 1

        if(this.VM.wizardInitType == this.INITTYPE.BOOKEXAM) {
          examLocationId = this.VM.selectExamStep.examLocation.value
          examBookedOn = this.VM.selectExamStep?.examDate.value
          examWizardId = this.VM.selectExamStep?.examWizardId
        }else{
          examLocationId = this.VM.reBookExamStep.examLocation.value
          examBookedOn = this.VM.reBookExamStep?.examDate.value
          examWizardId = this.VM.reBookExamStep?.examWizardId
        }

        let postData = {
          initType: this.VM.wizardInitType,
          olsUserId: this.clientData.olsUserId,
          clientId: this.clientData.clientId,
          examId: this.selectedExam.examId,
          dlClassId: this.selectedExam.selectedDlClassId,
          examLocationId: examLocationId,
          examBookedOn: examBookedOn,
          bookingDateFrom: this.selectedExam.examTypeId == 2 ? this.selectedExamTimeSlot?.examDateAndTimeFormatted : this.VM.selectExamStep.examDate.value, //this.selectedExamTimeSlot?.examDateAndTimeFormatted,
          examTypeId: this.selectedExam.examTypeId,
          isVerbal: false,
          wizardTypeId: this.VM.wizardType,
          examWizardId: examWizardId,
          examBookingId: this.VM.examBookingId,
        }

        axios
          .post('exams/addExamToCart', postData)
          .then(response => {
            this.VM.examAlert = response.data.examAlert;
            
            if (!this.VM.examAlert.hasAny) {
              //this.VM.currentStepId = -99;
            } else if (this.VM.examAlert.hasSuccess) {
              this.VM.currentStepId = this.STEPIDS.stepValidation;
            }
            this.VM.jumpToCart = response.data.jumpToCart;
          })
          .catch(error => console.log(error))
          .finally(() => {
            if (this.VM.jumpToCart) {
              this.redirectToFullURL(this.VM.shoppingCartWebAddress);
            }
          });
      }
    }


    
    getExamgroupTableHeaders() {
      return [
        { text: '', value: 'isSelected', sortable: false, width: '50px' },
        { text: this.VM.wizardLabels.IsMandatory, value: 'isMandatory', align: 'center', sortable: false, width: '' }, //120px
        { text: this.VM.wizardLabels.Exam, value: 'examNameHtml', sortable: false, width: '' }, //400px
        //{ text: this.VM.wizardLabels.DependantExams, value: 'mustPassItems', width: '', sortable: false }, //120px
        //{ text: this.VM.wizardLabels.CertificationsRequired, value: 'certificationsRequired', sortable: false },
        { text: '', value: 'scheduleExam', sortable: false, width: '' },
        { text: '', value: 'data-table-expand', sortable: false, width: '' },
      ];
    }

    getExamBookingsTableHeaders() {
      return [
        { text: '', value: 'rebookExam', sortable: false, width: '30px' },
        { text: '', value: 'cancelExam', sortable: false, width: '30px' },
        { text: this.VM.wizardLabels.Exam, value: 'examName', sortable: false }, //400px
        { text: this.VM.wizardLabels.ExamDate, value: 'bookingDateFromFormatted', sortable: false},
        // { text: this.VM.wizardLabels.ExamType, value: 'examType', width: '', sortable: false }, //120px
        // { text: this.VM.wizardLabels.ExamStatus, value: 'status', align: 'center', sortable: false, width: '' }, //120px
        // { text: this.VM.wizardLabels.ExamResult, value: 'examResult', sortable: false, width: '180' },
        // { text: this.VM.wizardLabels.ExamResultDate, value: 'examResultDateFormatted', sortable: false },
        // //{ text: this.VM.wizardLabels.Examiner, value: 'examinerId', sortable: false },
        // { text: this.VM.wizardLabels.ExpiresOn, value: 'validToFormatted', sortable: false, width: '130' },
        // { text: this.VM.wizardLabels.IsActive, value: 'isActive', sortable: false, width: '120' },
        // { text: this.VM.wizardLabels.ModifiedBy, value: 'modifiedByName', sortable: false },
        // { text: this.VM.wizardLabels.Modified, value: 'modifiedFormatted', sortable: false },
        //Test Code
        //Exam Code
        //Test Status
        // { text: '', value: 'scheduleExam', sortable: false, width: '250px' },
      ];
    }

    redirectToUrl(url: string) {
      return window.location.href = DEFAULT_ROOT_URL + url;
    }

    redirectToFullURL(url:string) {
      return window.location.href = url;
    }

    get hideDefaultFooter() {
      // if (this.VM.abstracts) {
      //   return this.VM.abstracts.length < 10;
      // }
      return false;
    }

    removeItem(clientId: any) {
      if (clientId == 0) return;
      //this.VM.abstracts = this.VM.abstracts.filter((element: any) => element.clientId != clientId);
    }

    scrollToTop() {
      window.scroll({
        top: 0,
        left: 0,
        behavior: 'smooth'
      });
    }

    resetErrorAlert() {
      this.VM.examAlert.error = ""
      this.VM.examAlert.hasAny = false
      this.VM.examAlert.hasError = false
      this.VM.examAlert.hasInfo = false
      this.VM.examAlert.hasSuccess = false
      this.VM.examAlert.hasWarning = false
      this.VM.examAlert.info = ""
      this.VM.examAlert.isError = false
      this.VM.examAlert.success = ""
      this.VM.examAlert.warning = ""
    }

  }
